import React from "react";
import Base from "./Base";
const Loading = ({ animated = true, backColor, color, progress, ...props }) => (
  <Base {...props} viewBox="0 0 66 66">
    {backColor && <circle stroke={backColor} strokeWidth="8" cx="33" cy="33" r="26" fill="none" />}
    {typeof progress !== 'undefined' &&
      <circle
        fill="none"
        strokeWidth="4"
        strokeLinecap="round"
        cx="33" cy="33"
        r="26"
        stroke={color || 'currentColor'}
        strokeDasharray="170"
        strokeDashoffset={Math.floor(170 * (1 - progress))}
      />
    }
    {typeof progress === 'undefined' &&
      <g>
        <animateTransform attributeName="transform" type="rotate" values="0 33 33;270 33 33" begin="0s" dur="1.4s" repeatCount="indefinite" />
        <circle fill="none" strokeWidth="4" strokeLinecap="round" cx="33" cy="33" r="26" strokeDasharray="187" strokeDashoffset="610" stroke={color || "currentColor"}>
          <animateTransform attributeName="transform" type="rotate" values="0 33 33;135 33 33;450 33 33" begin="0s" dur="1.4s" repeatCount="indefinite" />
          <animate attributeName="stroke-dashoffset" values="187;46.75;187" begin="0s" dur="1.4s" repeatCount="indefinite" />
        </circle>
      </g>
    }
  </Base>
)
export default Loading;